import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class StaticApiService {
  constructor(private http: HttpClient) {}

  getStaticContents(langCode: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/static-page`, {
      headers: { lang: langCode },
    });
  }

  createStaticPage(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/static-page`, data);
  }

  deleteStaticContent(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/static-page/deleteStaticPage/${id}`
    );
  }

  getStaticContentById(id: any): Observable<any> {
    return this.http.get(
      `${environment.authUrl}/static-page/translations/${id}`
    );
  }

  getStaticContentByIdLangCode(id: any, langCode: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/static-page/${id}`, {
      headers: { lang: langCode },
    });
  }

  updateStaticPage(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/static-page/${id}`, data);
  }
}
